module.exports = __webpack_public_path__ + "img/fast-delivery.4aff1adb.png";